import axios from 'axios';

const version = '/api/v1';

export default {
  sendLoginCreds(payload) {
    const { email, password } = payload;
    return axios({
      method: 'post',
      url: `${version}/user/login`,
      data: {
        email,
        password,
      },
    });
  },
  registerUser({ orgName, email, password }) {
    return axios({
      method: 'post',
      url: `${version}/user`,
      data: {
        orgName,
        email,
        password,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/api.js